import { NoneState } from "../states/NoneState";
import { ReducerAction } from '../ReducerAction';
import { ActionType } from "../ActionsTypes";

export const noneReducer = (state = new NoneState({}), action: ReducerAction) =>{
    switch(action.type){
        case ActionType.NONE:
            return new NoneState({
                ...state,
                text: "Hola mundo desde reducer"
            })
        default: return state;
    }
}